import React from "react";
import LiveAvailabilityCard from "../../components/LiveAvailabilityCard";

/**
 * Rap battle availability (RAP_BATTLES_AVAILABILITY). The weekly schedule is
 * the only gate: the backend hides the rap category, rejects queueing, and
 * excludes rap battles from feeds outside a window. Includes the "Rap battles
 * available" push switch.
 *
 * Thin wrapper over the shared LiveAvailabilityCard (also used for karaoke
 * LIVE on the Karaoke page).
 */
const RapAvailabilityCard = () => (
  <LiveAvailabilityCard
    title="Availability"
    featureLabel="Rap battles"
    endpoint="/admin/settings/rap-availability"
    responseKey="rapAvailability"
    showNotificationsToggle
    scheduleHelp="Users can queue for rap battles only while a window is open. Outside a window the rap category is hidden. The app shows “until” during a window and “back on” before the next one."
  />
);

export default RapAvailabilityCard;
